exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.buttons-container button[data-v-306f811a]{\r\n    font-size: 12px;\n}\n.buttons-container select[data-v-306f811a]{\r\n    font-size: 12px;\r\n    padding-top: 1px;\n}\n.control-buttons > .buttons-container[data-v-306f811a] {\r\n    width: 100px !important;\r\n    float: right;\n}\r\n", ""]);

// exports
